import { useUserContext } from '@/store/contexts/UserContext'

/**
 * User 관련 Custom Hook
 * UserContext를 래핑하여 사용하기 편리하게 만듦
 */
export function useUser() {
  return useUserContext()
}

